<template>
  <div>
    <v-app-bar app flat color="#FFFFFF" class="kg-navbar" :elevation="0" :extended="!isMobile" extension-height="60">
      <div class="navbar-inner">
        <v-container :class="isMobile ? 'px-2' : 'px-6'" class="w-100" style="max-width: 100%;">
          <v-row v-if="!isMobile" no-gutters align="center" justify="space-between">
            <v-col cols="auto" class="d-flex align-center brand-click" @click="goHome">
              <v-img src="/logo_new.png" alt="ELSON" class="brand-logo mr-3" contain />
              <span class="brand-text">ELSONIII</span>
            </v-col>

            <v-col cols="6" class="d-flex align-center justify-center">
              <div class="search-box" ref="desktopSearchBox">
                <input
                  type="text"
                  placeholder="ค้นหาสินค้า ร้านค้า และบริการของเรา"
                  class="search-input"
                  v-model="searchQuery"
                  @input="onSearchInput"
                  @keydown.enter="goSearchPage"
                  @focus="searchOpen = searchResults.length > 0 || searchLoading"
                  autocomplete="off"
                />
                <v-btn color="#F4811F" class="search-btn" dark elevation="0" @click="goSearchPage">
                  <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-icon id="nav-cart-icon" class="nav-icon" @click="goCart">mdi-cart-outline</v-icon>
              <v-icon class="nav-icon ml-3">mdi-bell-outline</v-icon>

              <v-btn v-if="!isLoggedIn" class="login-btn ml-4" color="#222424" dark rounded height="40"
                @click="goLogin">
                เข้าสู่ระบบ
              </v-btn>

              <v-menu v-else offset-y :nudge-bottom="10" :close-on-content-click="true" transition="fade-transition"
                attach=".kg-navbar" content-class="profile-menu-pop">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon class="ml-4" v-bind="attrs" v-on="on" height="40" width="40">
                    <v-avatar size="32">
                      <img v-if="profileImageUrl" :src="profileImageUrl"
                        :alt="currentUser ? currentUser.username : 'avatar'" @error="onAvatarError" />
                      <v-icon v-else>mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item @click="goProfile">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>บัญชีของฉัน</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="goOrders">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-receipt-text-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>คำสั่งซื้อของฉัน</v-list-item-title>
                  </v-list-item>

                  <v-divider class="my-1" />

                  <v-list-item @click="logout">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>ออกจากระบบ</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>

          <!-- Mobile View -->
          <v-row v-else no-gutters align="center" justify="space-between" class="mobile-bar flex-nowrap w-100 pl-2 pr-1">
            <!-- Brand -->
            <v-col cols="auto" class="d-flex align-center brand-click" @click="goHome">
              <v-avatar size="34" class="mr-2 rounded-lg elevation-1">
                <v-img :src="require('@/assets/logo.png')" alt="ELSON" contain />
              </v-avatar>
            </v-col>

            <!-- Search Bar -->
            <v-col class="grow px-2">
              <div class="search-box mobile-search-header d-flex align-center px-3" ref="mobileSearchBox" style="width: 100%;">
                <v-icon size="20" color="grey">mdi-magnify</v-icon>
                <input
                  type="text"
                  placeholder="ค้นหา..."
                  class="search-input py-2 grow"
                  style="font-size:14px; border:none; outline:none; background:transparent;"
                  v-model="searchQuery"
                  @input="onSearchInput"
                  @keydown.enter="goSearchPage"
                  @focus="searchOpen = searchResults.length > 0 || searchLoading"
                  autocomplete="off"
                />
              </div>
            </v-col>

            <!-- Actions -->
            <v-col cols="auto" class="d-flex align-center justify-end">
              <v-btn icon color="grey darken-3" @click="goCart">
                <v-icon size="26">mdi-cart-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <template v-slot:extension v-if="!isMobile">
        <div class="sub-navbar-inner desktop-only">
          <v-container class="px-6">
            <v-row justify="center" no-gutters class="menu-row">
              <span class="menu-item" :class="{ active: $route.name === 'home' }" @click="goHome">
                หน้าแรก
              </span>

              <span class="menu-item" :class="{ active: $route.name === 'board' }" @click="goBoard">
                กระดานข่าว
              </span>

              <span class="menu-item" :class="{ active: $route.name === 'marketplace' }" @click="goMarketplace">
                ตลาดชุมชน
              </span>

              <v-menu offset-y :nudge-bottom="10" open-on-hover :open-delay="80" :close-delay="200"
                transition="fade-transition" content-class="menu-pop">
                <template v-slot:activator="{ on, attrs }">
                  <span class="menu-item menu-dd-activator d-flex align-center" tabindex="0" v-bind="attrs" v-on="on">
                    ร้านค้า
                    <v-icon small class="ml-1 menu-icon">
                      mdi-chevron-down
                    </v-icon>
                  </span>
                </template>

                <v-list dense class="menu-dd">
                  <v-list-item @click="$router.push({ name: 'register_seller' })">
                    <v-list-item-title>เปิดร้านค้า</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="goSellerLogin">
                    <v-list-item-title>เข้าสู่ระบบร้านค้า</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <span class="menu-item" :class="{ active: $route.name === 'delivery' }" @click="goDelivery">
                สินค้าเดลิเวอรี่
              </span>

              <span class="menu-item" :class="{ active: $route.name === 'call_rider' }" @click="goCallRider">
                <v-icon small class="mr-1" style="vertical-align: middle; font-size: 15px;">mdi-motorbike</v-icon>
                เรียกไรเดอร์
              </span>

              <v-menu offset-y :nudge-bottom="10" open-on-hover :open-delay="80" :close-delay="200"
                transition="fade-transition" content-class="menu-pop">
                <template v-slot:activator="{ on, attrs }">
                  <span class="menu-item menu-dd-activator d-flex align-center"
                    :class="{ active: $route.name === 'aboutus' }" tabindex="0" v-bind="attrs" v-on="on">
                    เกี่ยวกับเรา
                    <v-icon small class="ml-1 menu-icon">
                      mdi-chevron-down
                    </v-icon>
                  </span>
                </template>

                <v-list dense class="menu-dd">
                  <v-list-item @click="goContactUs">
                    <v-list-item-title>ติดต่อเรา</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-container>
        </div>
      </template>
    </v-app-bar>

    <!-- Mobile Bottom Nav Bar (Rider Style) -->
    <div v-if="isMobile" class="rbn-wrapper">
      <nav class="rbn">
        <button
          class="rbn-item"
          :class="{ 'rbn-item--active': $route.name === 'home' }"
          @click="handleMobileNav('home')"
        >
          <div class="rbn-icon-wrap">
            <v-icon size="22">mdi-home-variant-outline</v-icon>
          </div>
          <span class="rbn-label">หน้าหลัก</span>
        </button>

        <button
          class="rbn-item"
          :class="{ 'rbn-item--active': $route.name === 'marketplace' }"
          @click="handleMobileNav('marketplace')"
        >
          <div class="rbn-icon-wrap">
            <v-icon size="22">mdi-storefront-outline</v-icon>
          </div>
          <span class="rbn-label">ตลาดชุมชน</span>
        </button>

        <button
          class="rbn-item"
          :class="{ 'rbn-item--active': $route.name === 'call_rider' }"
          @click="handleMobileNav('call_rider')"
        >
          <div class="rbn-icon-wrap" style="position:relative">
            <v-icon size="24" :color="$route.name === 'call_rider' ? 'deep-orange' : ''">mdi-motorbike</v-icon>
            <div v-if="$route.name !== 'call_rider'" style="position:absolute; top:-4px; right:-6px; background:#ef4444; width:8px; height:8px; border-radius:50%; border:1px solid white;"></div>
          </div>
          <span class="rbn-label" :class="{ 'deep-orange--text': $route.name === 'call_rider' }">เรียกรถ</span>
        </button>

        <button
          class="rbn-item"
          :class="{ 'rbn-item--active': $route.name === 'profile_user' || (!isLoggedIn && $route.name === 'login') }"
          @click="isLoggedIn ? handleMobileNav('profile') : handleMobileNav('login')"
        >
          <div class="rbn-icon-wrap">
            <v-avatar v-if="isLoggedIn && hasAvatar" size="24" class="elevation-1" style="margin-top:-2px">
              <img :src="profileImageUrl" @error="onAvatarError" />
            </v-avatar>
            <v-icon v-else-if="isLoggedIn" size="22" color="#F4811F">mdi-account-circle</v-icon>
            <v-icon v-else size="22">mdi-account-outline</v-icon>
          </div>
          <span class="rbn-label" :style="isLoggedIn ? 'color:#F4811F' : ''">
            {{ isLoggedIn ? 'ฉัน' : 'เข้าสู่ระบบ' }}
          </span>
        </button>

        <button class="rbn-item" @click="mobileDrawerOpen = true">
          <div class="rbn-icon-wrap">
            <v-icon size="22">mdi-dots-horizontal-circle-outline</v-icon>
          </div>
          <span class="rbn-label">เพิ่มเติม</span>
        </button>
      </nav>
    </div>

    <!-- Search Autocomplete Dropdown (fixed, outside app-bar stacking context) -->
    <div
      v-if="searchOpen && (searchResults.length > 0 || searchLoading)"
      class="search-dropdown-fixed"
      :style="dropdownStyle"
      v-click-outside="closeSearch"
    >
      <div v-if="searchLoading" class="search-loading">
        <v-progress-circular indeterminate size="18" width="2" color="#F4811F" />
        <span class="ml-2 caption grey--text">กำลังค้นหา...</span>
      </div>
      <template v-else>
        <div v-for="item in searchResults" :key="item.id" class="search-item" @click="goProduct(item)">
          <img :src="getProductThumb(item)" class="search-item-img" @error="e => e.target.style.display='none'" />
          <div class="search-item-info">
            <div class="search-item-name">{{ item.productName || item.name }}</div>
            <div class="search-item-price">฿{{ formatPrice(item.price) }}</div>
          </div>
          <v-icon size="16" color="#d1d5db" class="ml-auto">mdi-chevron-right</v-icon>
        </div>
        <div v-if="searchResults.length === 0" class="search-empty">ไม่พบสินค้า</div>
        <div v-if="searchResults.length >= 8" class="search-more" @click="goSearchPage">ดูผลการค้นหาทั้งหมด →</div>
      </template>
    </div>

    <!-- Mobile Bottom Sheet (More menu) -->
    <v-bottom-sheet v-if="isMobile" v-model="mobileDrawerOpen" scrollable>
      <v-sheet class="rbn-sheet">
        <div class="rbn-sheet-handle"></div>

        <div class="rbn-sheet-profile" v-if="isLoggedIn">
          <v-avatar size="48" rounded="lg">
            <img v-if="hasAvatar" :src="profileImageUrl" alt="avatar" @error="onAvatarError" />
            <v-avatar v-else size="48" color="#FFF5EC" rounded="lg">
              <v-icon size="28" color="#F4811F">mdi-account-circle</v-icon>
            </v-avatar>
          </v-avatar>
          <div class="rbn-sheet-profile-info">
            <div class="rbn-sheet-name">{{ currentUser ? currentUser.username : 'สมาชิก' }}</div>
            <div class="rbn-sheet-sub">ลูกค้าทั่วไป</div>
          </div>
          <v-btn icon @click="mobileDrawerOpen = false">
            <v-icon color="#9CA3AF">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <div class="rbn-sheet-profile" v-else>
          <v-avatar size="48" rounded="lg" color="#F3F4F6">
             <v-icon size="28" color="#9CA3AF">mdi-account</v-icon>
          </v-avatar>
          <div class="rbn-sheet-profile-info">
            <div class="rbn-sheet-name">ยินดีต้อนรับ</div>
            <div class="rbn-sheet-sub text-primary font-weight-bold" @click="handleMobileNav('login')">เข้าสู่ระบบ / สมัครสมาชิก</div>
          </div>
          <v-btn icon @click="mobileDrawerOpen = false">
            <v-icon color="#9CA3AF">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider class="mb-4"></v-divider>

        <div class="rbn-sheet-grid">
          <button class="rbn-sheet-item" @click="handleMobileNav('delivery')">
            <div class="rbn-sheet-icon">
              <v-icon size="24" color="info">mdi-truck-fast-outline</v-icon>
            </div>
            <span class="rbn-sheet-label">เดลิเวอรี่</span>
          </button>
          
          <button class="rbn-sheet-item" @click="handleMobileNav('board')">
            <div class="rbn-sheet-icon">
              <v-icon size="24" color="purple">mdi-bulletin-board</v-icon>
            </div>
            <span class="rbn-sheet-label">กระดานข่าว</span>
          </button>
          
          <button v-if="!isLoggedIn" class="rbn-sheet-item" @click="handleMobileNav('login_seller')">
            <div class="rbn-sheet-icon">
              <v-icon size="24" color="teal">mdi-storefront-outline</v-icon>
            </div>
            <span class="rbn-sheet-label">ระบบร้านค้า</span>
          </button>
          
          <button v-if="!isLoggedIn" class="rbn-sheet-item" @click="handleMobileNav('register_seller')">
            <div class="rbn-sheet-icon">
              <v-icon size="24" color="indigo">mdi-store-plus-outline</v-icon>
            </div>
            <span class="rbn-sheet-label">ร้านค้าใหม่</span>
          </button>
        </div>

        <div class="rbn-sheet-logout" v-if="isLoggedIn">
          <v-btn block outlined color="error" rounded @click="logout" class="logout-btn">
            <v-icon left>mdi-logout</v-icon>
            ออกจากระบบ
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { logoutApi } from "@/services/api/auth";
import { getProfileApi } from "@/services/api/userServices";
import { searchProductsApi } from "@/services/api/product";
import { getProductImage } from "@/utils/image";

export default {
  name: "Navbar",
  data() {
    return {
      avatarError: false,
      user: null,
      mobileDrawerOpen: false,
      searchQuery: "",
      searchResults: [],
      searchLoading: false,
      searchOpen: false,
      searchTimer: null,
    };
  },

  computed: {
    isMobile() {
      const bp = this.$vuetify.breakpoint;
      return bp && bp.width <= 1024;
    },

    isLoggedIn() {
      const s = this.$store;
      if (s && s.getters && s.getters.isAuthenticated) return true;
      if (localStorage.getItem("token")) return true;
      try {
        const vuex = JSON.parse(localStorage.getItem("vuex") || "{}");
        return !!(vuex.auth && (vuex.auth.token || vuex.auth.accessToken));
      } catch {
        return false;
      }
    },

    currentUser() {
      return (
        (this.$store &&
          this.$store.state &&
          this.$store.state.auth &&
          this.$store.state.auth.user) ||
        this.user ||
        null
      );
    },

    profileImageUrl() {
      if (this.avatarError) return "";
      const user = this.currentUser;
      if (!user || !user.profileImage) return "";
      const raw = (user.profileImage || "").trim();

      if (/^https?:\/\//i.test(raw)) return raw;

      const apiBase = (
        process.env.VUE_APP_API_URL || "http://localhost:3000"
      ).replace(/\/+$/, "");
      return raw.startsWith("/") ? `${apiBase}${raw}` : `${apiBase}/${raw}`;
    },
    hasAvatar() {
      return !!this.profileImageUrl;
    },

    dropdownStyle() {
      const ref = this.$refs.desktopSearchBox || this.$refs.mobileSearchBox;
      if (!ref) return { display: 'none' };
      const rect = ref.getBoundingClientRect();
      return {
        position: 'fixed',
        top: (rect.bottom + 6) + 'px',
        left: rect.left + 'px',
        width: rect.width + 'px',
      };
    },
  },

  watch: {
    profileImageUrl() {
      this.avatarError = false;
    },

    async isLoggedIn(newVal, oldVal) {
      if (newVal && !oldVal) {
        await this.fetchProfile();
      }
    },

    mobileMenu(val) {
      const body = document.body;
      const html = document.documentElement;
      if (val) {
        body.style.overflow = "hidden";
        html.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
        html.style.overflow = "";
      }
    },
  },

  async created() {
    if (this.isLoggedIn) {
      await this.fetchProfile();
    }
  },

  beforeDestroy() {
    const body = document.body;
    const html = document.documentElement;
    body.style.overflow = "";
    html.style.overflow = "";
  },

  methods: {
    async fetchProfile() {
      const accessToken =
        this.$store && this.$store.getters
          ? this.$store.getters.accessToken
          : null;

      if (!accessToken) {
        return;
      }

      try {
        const user = await getProfileApi();
        this.user = user;
        if (this.$store && this.$store.commit) {
          this.$store.commit("auth/SET_USER", user);
        }
        this.avatarError = false;
      } catch (e) {
        console.error("[NAVBAR] getProfile error", e);
      }
    },

    onAvatarError() {
      this.avatarError = true;
    },

    safeGo({ name, params = {}, query = {} }) {
      const sameName = this.$route.name === name;
      const sameParam =
        JSON.stringify(this.$route.params || {}) === JSON.stringify(params);
      const sameQuery =
        JSON.stringify(this.$route.query || {}) === JSON.stringify(query);
      if (sameName && sameParam && sameQuery) return;

      this.$router.push({ name, params, query }).catch((err) => {
        if (!err || err.name !== "NavigationDuplicated") {
          console.error("[NAVBAR] router push error:", err);
        }
      });
    },

    goHome() {
      this.safeGo({ name: "home" });
    },
    goLogin() {
      this.safeGo({ name: "login" });
    },
    goSellerLogin() {
      this.safeGo({ name: "login_seller" });
    },
    goServices() {
      this.safeGo({ name: "aboutus" });
    },
    goMarketplace() {
      this.safeGo({ name: "marketplace" });
    },
    goContactUs() {
      this.safeGo({ name: "contactus" });
    },
    goDelivery() {
      this.safeGo({ name: "delivery" });
    },
    goCallRider() {
      this.safeGo({ name: "call_rider" });
    },
    goBoard() {
      this.safeGo({ name: "board" });
    },
    goProfile() {
      this.safeGo({ name: "profile_user", query: { tab: "profile_info" } });
    },
    goOrders() {
      this.safeGo({ name: "profile_user", query: { tab: "orders_tracking" } });
    },
    goCart() {
      this.safeGo({ name: "cart" });
    },

    async logout() {
      try {
        await logoutApi().catch(() => { });
      } finally {
        await this.$store
          .dispatch("logout", { authGroup: "user" })
          .catch(() => { });

        this.user = null;

        this.safeGo({ name: "home" });
      }
    },

    getProductThumb(item) {
      return getProductImage(item);
    },

    formatPrice(price) {
      if (!price && price !== 0) return "0.00";
      return parseFloat(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    onSearchInput() {
      clearTimeout(this.searchTimer);
      const q = this.searchQuery.trim();
      if (!q) {
        this.searchResults = [];
        this.searchOpen = false;
        return;
      }
      this.searchLoading = true;
      this.searchOpen = true;
      this.searchTimer = setTimeout(async () => {
        try {
          this.searchResults = await searchProductsApi(q, 8);
        } catch {
          this.searchResults = [];
        } finally {
          this.searchLoading = false;
        }
      }, 300);
    },

    closeSearch() {
      this.searchOpen = false;
    },

    goProduct(item) {
      this.searchOpen = false;
      this.searchQuery = "";
      this.searchResults = [];
      this.safeGo({ name: "product_detail", params: { id: item.id } });
    },

    goSearchPage() {
      const q = this.searchQuery.trim();
      if (!q) return;
      this.searchOpen = false;
      this.searchQuery = "";
      this.searchResults = [];
      this.safeGo({ name: "all_products", query: { q } });
    },

    toggleMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
    },

    handleMobileNav(name) {
      this.mobileDrawerOpen = false;
      this.mobileMenu = false;
      switch (name) {
        case "home":
          return this.goHome();
        case "board":
          return this.goBoard();
        case "delivery":
          return this.goDelivery();
        case "call_rider":
          return this.goCallRider();
        case "marketplace":
          return this.goMarketplace();
        case "register_seller":
          return this.$router.push({ name: "register_seller" });
        case "login_seller":
          return this.goSellerLogin();
        case "aboutus":
          return this.goServices();
        case "login":
          return this.goLogin();
        case "profile":
          return this.goProfile();
      }
    },
  },
};
</script>

<style scoped>
.kg-navbar {
  border-bottom: 1px solid #e5e7eb;
  z-index: 30;
}

::v-deep .kg-navbar .v-toolbar__content {
  padding: 0 !important;
  display: flex;
  align-items: center;
}

::v-deep .kg-navbar .v-toolbar__extension {
  padding: 0 !important;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  align-items: center;
}

.navbar-inner,
.sub-navbar-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
  width: 100%;
}

.brand-logo {
  width: 42px;
  height: 42px;
  border-radius: 8px;
}

.brand-text {
  font-size: 20px;
  font-weight: 600;
  color: #F4811F;
}

.brand-click {
  cursor: pointer;
  transition: opacity 0.2s;
}

.brand-click:hover {
  opacity: 0.85;
}

.search-box {
  width: 100%;
  max-width: 640px;
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 8px;
  overflow: visible;
  border: 1px solid #e5e7eb;
  position: relative;
}

.search-dropdown-fixed {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  z-index: 99999;
  overflow: hidden;
  max-height: 400px;
  overflow-y: auto;
}

.search-loading {
  display: flex;
  align-items: center;
  padding: 14px 16px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s;
}
.search-item:hover { background: #f9fafb; }

.search-item-img {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.search-item-info { flex: 1; min-width: 0; }
.search-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-item-price {
  font-size: 12px;
  color: #F4811F;
  font-weight: 700;
  margin-top: 2px;
}

.search-empty {
  padding: 16px;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
}

.search-more {
  padding: 10px 16px;
  text-align: center;
  font-size: 13px;
  color: #F4811F;
  font-weight: 600;
  cursor: pointer;
  border-top: 1px solid #f1f5f9;
}
.search-more:hover { background: #fff5ed; }

.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 14px;
  font-size: 14px;
  background: transparent;
}

.search-btn {
  min-width: 52px;
  border-radius: 8px;
  margin-right: 3px !important;
}

.nav-icon {
  font-size: 26px;
  color: #111827;
  cursor: pointer;
}

.login-btn {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 4px;
  width: 130px;
}

::v-deep .v-avatar .v-icon {
  color: #111827;
  font-size: 28px;
}

::v-deep .v-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

::v-deep .profile-menu-pop {
  z-index: 3000 !important;
}

.profile-menu-pop ::v-deep .v-list-item__title {
  font-size: 15px;
  font-weight: 500;
  color: #111827;
}

.profile-menu-pop ::v-deep .v-list-item__icon {
  color: #F4811F;
}

/* sub menu (desktop) */
.menu-row {
  padding: 8px 0;
  gap: 34px;
}

.menu-item {
  font-size: 14px;
  color: #111827;
  cursor: pointer;
  transition: color 0.2s;
}

.menu-item:hover {
  color: #F4811F;
}

.menu-item.active {
  color: #F4811F !important;
  font-weight: 500;
}

.menu-icon {
  font-size: 16px;
  color: #111827;
  transition: transform 0.2s, color 0.2s;
}

.menu-item:hover .menu-icon {
  color: #F4811F;
  transform: rotate(180deg);
}

.menu-pop {
  margin-top: 6px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.menu-dd {
  min-width: 200px;
}

.menu-dd ::v-deep .v-list-item {
  min-height: 36px;
}

.menu-dd ::v-deep .v-list-item__title {
  font-size: 14px;
}

.mobile-bar {
  padding: 0;
  height: 56px;
  width: 100%;
}

.mobile-search-header {
  background: #f3f4f6;
  border-radius: 8px;
}

/* ─── Mobile Bottom Nav (Rider Inspired) ─── */
.rbn-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background: transparent;
}

.rbn {
  display: flex;
  align-items: stretch;
  background: white;
  border-top: 1px solid #F3F4F6;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.05);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.rbn-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 4px 6px;
  text-decoration: none;
  color: #9CA3AF;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif;
  transition: color 0.2s;
  -webkit-tap-highlight-color: transparent;
  min-height: 56px;
}

.rbn-item--active {
  color: #F4811F;
}

.rbn-icon-wrap {
  width: 36px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: background 0.2s, transform 0.15s;
}

.rbn-item--active .rbn-icon-wrap {
  background: rgba(244, 129, 31, 0.1);
  transform: translateY(-1px);
}

.rbn-label {
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

/* ─── Mobile "More" Sheet ─── */
.rbn-sheet {
  border-radius: 24px 24px 0 0 !important;
  padding: 0 16px calc(20px + env(safe-area-inset-bottom, 0px));
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif;
  max-height: 70vh;
  overflow-y: auto;
}

.rbn-sheet-handle {
  width: 40px;
  height: 4px;
  background: #E5E7EB;
  border-radius: 4px;
  margin: 12px auto 16px;
}

.rbn-sheet-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0 16px;
}
.rbn-sheet-profile-info { flex: 1; min-width: 0; }
.rbn-sheet-name { font-size: 16px; font-weight: 700; color: #111827; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rbn-sheet-sub  { font-size: 13px; color: #6B7280; margin-top: 2px; }

.rbn-sheet-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.rbn-sheet-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 8px;
  border-radius: 16px;
  background: #F9FAFB;
  text-decoration: none;
  color: #374151;
  border: none;
  transition: background 0.15s, transform 0.15s;
  -webkit-tap-highlight-color: transparent;
}
.rbn-sheet-item:active { transform: scale(0.96); }

.rbn-sheet-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.rbn-sheet-label {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
}

.rbn-sheet-logout { padding: 0 4px; }

.logout-btn {
  height: 48px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  border-radius: 14px !important;
  letter-spacing: 0 !important;
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

.mobile-avatar-btn ::v-deep .v-avatar {
  background: #f9fafb;
}

.mobile-avatar-btn ::v-deep .v-avatar .v-icon {
  font-size: 22px;
  color: #111827;
}

@media (max-width: 1024px) {
  .desktop-only {
    display: none !important;
  }
  
  ::v-deep .kg-navbar .v-toolbar__extension {
    display: none !important;
  }

  .navbar-inner {
    padding: 0 16px;
  }

  .search-box {
    max-width: 100%;
  }

  .menu-row {
    gap: 16px;
    flex-wrap: wrap;
  }
}

@media (max-width: 768px) {

  .navbar-inner,
  .sub-navbar-inner {
    padding: 0 16px;
  }
}
</style>
